import React, { useEffect } from "react";
import VerifyInvitationComponent from "./verify-invitation.page";
import { verifyEmployee } from "modules/public/redux/action";
import { useDispatch, useSelector } from "react-redux"
import { useParams, useLocation, useHistory } from "react-router-dom"
import { selectLoading } from "modules/notification";
import { unwrapResult } from "@reduxjs/toolkit";
import { setEmployee } from "../../redux/slice/signup.slice"
import { clearSession } from "modules/admin/redux/slice"

function VerifyInvitationContainer() {
  const dispatch = useDispatch()
  const { id: routeId } = useParams();
  const { search, pathname } = useLocation();
  const query = new URLSearchParams(search);
  const token = query.get('token');
  const history = useHistory();
  const isFetching = useSelector((state) => selectLoading(state, verifyEmployee.typePrefix));
  const [hasVerified, setHasVerified] = React.useState(false);
  
  
  // Fallback
  const manualId = pathname.split('/verify-email/')[1];
  const id = routeId || manualId;
  
  
  useEffect(() => {
    if (token && id && !hasVerified) {
      setHasVerified(true);
      
      dispatch(setEmployee({ id, token }))
      
      dispatch(verifyEmployee({ id, token }))
        .then(unwrapResult)
        .then((r) => {
          dispatch(clearSession());
          localStorage.clear();
          
          // Force full page reload
          setTimeout(() => {
            window.location.href = "/signup";
          }, 200);
        })
        .catch((error) => {
          dispatch(clearSession());
          history.push("/invalid")
        });
    }
    else {
      //redirect to expired page
    }
  }, [dispatch, history, token, id, hasVerified]);

  return <VerifyInvitationComponent isFetching={isFetching} />;
}


export default VerifyInvitationContainer;
